"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.analytics = void 0;
const appstage_shared_events_manager_1 = require("@24i/appstage-shared-events-manager");
const constants_1 = require("./constants");
class Analytics {
    constructor() {
        this.events = new appstage_shared_events_manager_1.EventsManager();
        this.onlyOnceAlreadySent = [];
        this.lastPayloadForEvent = {};
        this.clients = {};
        this.generalAppData = {};
        this.appInfo = {};
        this.userInfo = {};
    }
    addClient(client, events) {
        if (this.clients[client.name]) {
            throw new Error(`${client.name} analytics client is already registered.`);
        }
        const eventsToRegister = Array.isArray(events)
            ? events
            : constants_1.EVENT_NAMES.filter(events.test.bind(events));
        const registeredEvents = {};
        eventsToRegister.forEach((eventName) => {
            const listener = (payload) => {
                client.onEvent(eventName, payload);
            };
            this.events.addEventListener(eventName, listener);
            registeredEvents[eventName] = listener;
        });
        this.clients[client.name] = {
            client,
            registeredEvents,
        };
    }
    removeClient(client) {
        if (this.clients[client.name]) {
            const { registeredEvents } = this.clients[client.name];
            Object.keys(registeredEvents).forEach((eventName) => {
                // @ts-ignore - specific payload typing
                this.events.removeEventListener(eventName, registeredEvents[eventName]);
            });
            delete this.clients[client.name];
        }
    }
    serializePayload(payload) {
        const orderedPayload = payload &&
            Object.keys(payload)
                .sort()
                .reduce((obj, key) => {
                obj[key] = payload[key];
                return obj;
            }, {});
        return JSON.stringify(orderedPayload, (key, value) => {
            if (key === 'timestamp') {
                return undefined;
            }
            return value;
        });
    }
    triggerEvent(event, triggerPayload = undefined) {
        const fullPayload = Object.assign(Object.assign(Object.assign(Object.assign({}, this.generalAppData), this.appInfo), this.userInfo), triggerPayload);
        if (constants_1.ONLY_ONCE_EVENTS.includes(event)) {
            const serializedPayload = `${event} - ${this.serializePayload(fullPayload)}`;
            if (this.onlyOnceAlreadySent.includes(serializedPayload))
                return;
            this.onlyOnceAlreadySent.push(serializedPayload);
        }
        if (constants_1.UNREPEATABLE_EVENTS.includes(event)) {
            const serializedPayload = this.serializePayload(fullPayload);
            if (this.lastPayloadForEvent[event] === serializedPayload)
                return;
            this.lastPayloadForEvent[event] = serializedPayload;
        }
        // @ts-ignore - payload typing
        this.events.triggerEvent(event, fullPayload);
    }
    setAppInfo(data) {
        this.appInfo = Object.assign(Object.assign({}, this.appInfo), data);
    }
    setUserInfo(data) {
        this.userInfo = Object.assign(Object.assign({}, this.userInfo), data);
    }
    setGeneralAppDataInfo(data) {
        this.generalAppData = Object.assign(Object.assign({}, this.generalAppData), data);
    }
}
exports.analytics = new Analytics();
